import { render, staticRenderFns } from "./FileModificationStatusChip.vue?vue&type=template&id=0b27df26"
import script from "./FileModificationStatusChip.vue?vue&type=script&lang=ts"
export * from "./FileModificationStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports